import React from 'react';
import { StyledCheckBox } from './styled';

const CheckBoxSingle = ({ ...props }) => {
  return <StyledCheckBox {...props} />;
};

export default CheckBoxSingle;
